<script>
  import { onMount } from "svelte";
  import {Link} from "svelte-routing";

  let tools = [
    {
      "tool_name": "FORECasT-repair",
      "url": "https://elixir.ut.ee/forecast-repair/",
      "methods": "CRISPR/Cas9",
      "target_organisms": ["Human"],
      "platform": "Website",
      "focus": "Editing outcomes"
    },
    {
      "tool_name": "FORECasT",
      "url": "https://elixir.ut.ee/forecast/",
      "methods": "CRISPR/Cas9",
      "target_organisms": ["Human"],
      "platform": "Website",
      "focus": "Editing outcomes"
    },
    {
      "tool_name": "FORECasT-BE",
      "url": "https://elixir.ut.ee/forecast-be/",
      "methods": "Base editing",
      "target_organisms": ["Human"],
      "platform": "Website",
      "focus": "Editing outcomes"
    },
    {
      "tool_name": "MinsePIE",
      "url": "https://elixir.ut.ee/minsepie/",
      "methods": "Prime editing",
      "target_organisms": ["Human"],
      "platform": "Website",
      "focus": "Editing outcomes"
    },
    {
      "tool_name": "CRISPOR",
      "url": "http://crispor.gi.ucsc.edu/",
      "methods": "CRISPR/Cas9",
      "target_organisms": ["Human", "Bacteria", "Virus", "Other"],
      "platform": "Website",
      "focus": "Guide sequence design"
    },
    {
      "tool_name": "PE-Designer",
      "url": "http://www.rgenome.net/pe-designer/",
      "methods": "Prime editing",
      "target_organisms": ["Human", "Bacteria", "Virus", "Other"],
      "platform": "Website",
      "focus": "Guide sequence design"
    },
    {
      "tool_name": "pegIT",
      "url": "https://pegit.giehmlab.dk/",
      "methods": "Prime editing",
      "target_organisms": ["Human", "Bacteria", "Virus", "Other"],
      "platform": "Website",
      "focus": "Guide sequence design"
    },
    {
      "tool_name": "PE-analyzer",
      "url": "http://www.rgenome.net/pe-analyzer/",
      "methods": "Prime editing",
      "target_organisms": ["Human", "Bacteria", "Virus", "Other"],
      "platform": "Website",
      "focus": "Analysis"
    },
    {
      "tool_name": "BE-Hive",
      "url": "https://www.crisprbehive.design/single",
      "methods": "Base editing",
      "target_organisms": ["Human", "Other"],
      "platform": "Website",
      "focus": "Editing outcomes"
    },
    {
      "tool_name": "In-Delphi",
      "url": "https://indelphi.giffordlab.mit.edu/single",
      "methods": "CRISPR/Cas9",
      "target_organisms": ["Human", "Other"],
      "platform": "Website",
      "focus": "Editing outcomes"
    },
    {
      "tool_name": "DeepBE",
      "url": "https://deepcrispr.info/DeepBE/",
      "methods": "Base editing",
      "target_organisms": ["Human"],
      "platform": "Website",
      "focus": "Editing outcomes"
    },
    {
      "tool_name": "ACEofBASEs",
      "url": "https://aceofbases.cos.uni-heidelberg.de/index.html",
      "methods": "Base editing",
      "target_organisms": ["Human", "Bacteria", "Other"],
      "platform": "Website",
      "focus": "Off-targets"
    },
    {
      "tool_name": "beditor",
      "url": "https://github.com/rraadd88/beditor",
      "methods": "Base editing",
      "target_organisms": ["Human"],
      "platform": "GUI, CLI",
      "focus": "Guide sequence design"
    }
  ];


  let filter = {
    methods: '',
    target_organisms: '',
    platform: '',
    focus: ''
  };

  let filteredTools = tools;

  function applyFilters() {
    filteredTools = tools.filter(tool =>
      (filter.methods === '' || tool.methods.includes(filter.methods)) &&
      (filter.target_organisms === '' || tool.target_organisms.includes(filter.target_organisms)) &&
      (filter.platform === '' || tool.platform.includes(filter.platform)) &&
      (filter.focus === '' || tool.focus.includes(filter.focus))
    );
  }

  onMount(() => {
    applyFilters();
  });

  $: {
    applyFilters();
  }
</script>

<main>
    <section class="section">
        <div class="landing-header">
            <div class="back-btn">
                <Link to="/" class="button is-rounded is-inverted"><i class="fa fa-arrow-left" aria-hidden="true"></i><span class="back-btn-text">&nbsp;Back</span></Link>
            </div>
            <h1 class="landing-title">
                One-Stop-Shop
            </h1>
            <p class="landing-description">Gateway to Genome Engineering Web Tools</p>
        </div>
        <div class="gradient-background"></div>
        <br><br>
        <div class="container">

            <div class="field is-grouped is-grouped-multiline">
                <div class="control">
                    <div class="select">
                        <select bind:value={filter.methods} on:change={applyFilters}>
                            <option value="">All Methods</option>
                            <option>CRISPR/Cas9</option>
                            <option>Base editing</option>
                            <option>Prime editing</option>
                        </select>
                    </div>
                </div>
                <div class="control">
                    <div class="select">
                        <select bind:value={filter.target_organisms} on:change={applyFilters}>
                            <option value="">All Organisms</option>
                            <option>Human</option>
                            <option>Bacteria</option>
                            <option>Virus</option>
                            <option>Other</option>
                        </select>
                    </div>
                </div>
                <div class="control">
                    <div class="select">
                        <select bind:value={filter.platform} on:change={applyFilters}>
                            <option value="">All Platforms</option>
                            <option>Website</option>
                            <option>GUI</option>
                            <option>CLI</option>
                        </select>
                    </div>
                </div>
                <div class="control">
                    <div class="select">
                        <select bind:value={filter.focus} on:change={applyFilters}>
                            <option value="">All Modalities</option>
                            <option>Editing outcomes</option>
                            <option>Guide sequence design</option>
                            <option>Analysis</option>
                            <option>Off-targets</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="columns is-multiline">
                {#each filteredTools as tool}
                    <div class="column is-4">
                        <div class="card">
                            <div class="card-content">
                                <p>
                                    <a target="_blank" href={tool.url} rel="noopener noreferrer">
                                    {tool.tool_name}
                                        <span class="icon">
                                            <i class="fa fa-external-link-alt"></i>
                                        </span>
                                    </a>
                                </p>
                                <div class="divider"></div>

                                <p><strong>Methods:</strong> {tool.methods}</p>
                                <p><strong>Target Organisms:</strong> {tool.target_organisms.join(', ')}</p>
                                <p><strong>Platform:</strong> {tool.platform}</p>
                                <p><strong>Modality:</strong> {tool.focus}</p>
                            </div>
                        </div>
                    </div>
                {/each}
            </div>
        </div>
    </section>
</main>


<style>

    @media (max-width: 400px) {
        .back-btn-text {
            display: none;
        }
    }

    .divider {
        margin-bottom: 8px;
    }

    .landing-header {
        text-align: center;
        color: white;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        text-align: center;
    }


    .landing-header .back-btn {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
    }

    .landing-header .landing-title {
        z-index: 0;
    }

    .landing-header .landing-description {
        margin-top: 0;
    }

    .landing-title {
        text-transform: uppercase;
        font-size: 1.5em;
        margin-bottom: 20px;
        font-family: 'Oswald', sans-serif;
    }

    .landing-description {
        font-size: 2em;
    }

    .gradient-background {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(to bottom, rgba(10, 10, 10, 0.95) 50%, #f9f9f9 50%);
        z-index: -1;
    }

</style>
